import Basic from "./Basic";
import Error from "./Error";

export default {
  Basic,
  Error
};
